import React from 'react';
import { Row, Col, Button, Tooltip, Icon } from "antd";
import { useTranslation } from 'react-i18next';
import CardCampaignStatusHolder from './Styles/CardCampaignStatusStyle';
import { hasAccessRole, isCampaignFinished } from '../services/utils';
import UserRoleEnum from "../constants/UserRoleEnum";
import moment from "moment";

const CardCampaignStatusComponent = ({
  currentCampaign,
  user,
  setIsCampaignPaused,
  setActive,
  isCampaignPaused,
  editCampaignActive,
  allDisplaysAreOwn
}) => {
  const { t } = useTranslation();

  const isFinished = () => isCampaignFinished(currentCampaign && currentCampaign.end_date);

  const getDisplayStatus = () => {
    const isInConstruction = !editCampaignActive
    if (isInConstruction) return 'in progress'
    if (!currentCampaign) return ''
    if (isFinished()) return 'Finalized'
    if (isCampaignPaused) return 'paused_status'
    if (currentCampaign.status) return currentCampaign.status
    return ''
  }

  const status = getDisplayStatus();

  const getStatusClassName = (status) => {
    if (!status) return '';
    
    switch (status) {
      case 'pending':
        return 'statusPending';
      case 'ready':
      case 'approved':
        return 'statusReady';
      case 'cancelled_by_user':
      case 'cancelled':
        return 'statusCancelled';
      case 'paused_status':
        return 'statusPaused';
      case 'proposal':
        return 'statusProposal';
      case 'finalized':
      case 'finished':
        return 'statusFinished';
      default:
        return '';
    }
  }

  const handleIsPausedToggle = () => {
    const newPausedState = !isCampaignPaused
    setIsCampaignPaused(newPausedState)
    setActive(newPausedState)
  }

  const campaignFinished = isFinished();

  return (
    <CardCampaignStatusHolder>
      <div className="cardGeneral">
        <Row justify="center">
          <Col>
            <div>
              <div className='statusTitle'>{t("Status")}</div>
              <div className='statusContainer'>
                <span className={`statusName ${getStatusClassName(status)}`}>{t(`${status}`)}</span>
                {(editCampaignActive
                  && currentCampaign.payment_status !== 'pending'
                  && currentCampaign.payment_status !== 'cancelled'
                  && user
                  && (hasAccessRole(user.roles, [UserRoleEnum.superAdmin, UserRoleEnum.superModeratorAgency]) || allDisplaysAreOwn)) ?
                  (status !== 'pending' && status !== 'proposal' && !campaignFinished && (
                    <Tooltip title={isCampaignPaused ? t('Resume campaign') : t('Pause campaign')}>
                      <Button
                        shape="circle"
                        className='buttonActionsGroup'
                        size="small"
                        onClick={handleIsPausedToggle}
                      >
                        <Icon type={isCampaignPaused ? "caret-right" : "pause"} />
                      </Button>
                    </Tooltip>
                  ))
                  : null}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </CardCampaignStatusHolder>
  );
};

export default CardCampaignStatusComponent;